import { capitalize } from '../../lib/string/lib';
import { createSyncActionTypeValue } from '../actionTypes/lib';
import { SyncActionCreatorOptions } from '../types/Options';
import { SyncActionTypeValue } from '../actionTypes/types';
import { SyncVerb } from '../types/Verbs';
import {
	SyncActionCreator,
	SyncActionCreatorDataValue,
	SyncActionCreatorKey,
	SyncActionCreatorNameOptions,
	SyncActionCreatorTypeValue
} from './types';

export function createSyncActionCreatorKey<SV extends SyncVerb, N extends string>(
	options: SyncActionCreatorNameOptions<SV, N>
): SyncActionCreatorKey<SV, N> {
	const { syncVerb, name } = options;
	const syncVerbLowercased = syncVerb.toLowerCase();
	const nameCapitalized = capitalize(name);

	return `${syncVerbLowercased}${nameCapitalized}` as SyncActionTypeValue<SV, N>;
}

export function createSyncActionCreatorDataValue<SV extends SyncVerb, N extends string, RQ>(
	options: Omit<SyncActionCreatorOptions<SV, N>, 'hasRequest'>
): SyncActionCreatorDataValue<SV, N, RQ> {
	const actionTypeValue = createSyncActionTypeValue<SV, N>(options);

	return function(data: RQ) {
		return {
			data,
			type: actionTypeValue
		};
	};
}

function createSyncActionCreatorTypeValue<SV extends SyncVerb, N extends string>(
	options: SyncActionCreatorOptions<SV, N>
): SyncActionCreatorTypeValue<SV, N> {
	const actionTypeValue = createSyncActionTypeValue<SV, N>(options);

	return function() {
		return {
			type: actionTypeValue
		};
	};
}

export function createSyncActionCreator<SV extends SyncVerb, N extends string, RQ>(
	options: SyncActionCreatorOptions<SV, N>
): SyncActionCreator<SV, N, RQ> {
	return options.hasRequest ?
		createSyncActionCreatorDataValue(options) as SyncActionCreator<SV, N, RQ> :
		createSyncActionCreatorTypeValue(options) as SyncActionCreator<SV, N, RQ>;
}
